var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeViewInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "24px",
    viewBox: "0 0 16 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_tree view_inactive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_tree-view_inactive",
    transform: "translate(-6.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-30",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(6.000000, 4.000000)",
    stroke: "#80959D"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 11.5,
    y: 19.5,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 11.5,
    y: 5.5,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 11.5,
    y: 12.5,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-18",
    points: "3 5 3 8 11.1231056 8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-18-Copy",
    points: "3 8 3 14 11 14"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-18-Copy-2",
    points: "3 12 3 21 11 21"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeViewInactive);
export default __webpack_public_path__ + "static/media/tree-view-inactive.0a5243cbf8d2dd0f828e6d83baae9883.svg";
export { ForwardRef as ReactComponent };